/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  ProgressBar,
  Card,
  CardHeader,
  CardBody,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCartPlus,
  faCheck,
  faCircleExclamation,
  faFileCircleExclamation,
  faIdCard,
  faMapMarkerAlt,
  faTimes,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css"; 
import CartPersonDetails from "./FormSteps/CartPersonDetails";
import CartDetails from "./FormSteps/CartDetails";
import SuccessMessage from "./FormSteps/Success";
import Identity from "./FormSteps/Indentity";
import BreadCrumbs from "../../../components/BreadCrumbs";

const AddCart: React.FC = () => {
  const [step, setStep] = useState(0);
  const [isError, setIsError] = useState(true);

  const nextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };

  const retry = () => {
    setIsError(false);
    setStep(0);
  };

  const finish = () => {
  };

  const progressPercentage = (step / 3) * 100;

  return (
    <>
      <BreadCrumbs hasSubMenus={false} />
      <Card className="mt-3">
        <CardHeader className="bg-white">
          <h4>Add Cart</h4>
        </CardHeader>
        <CardBody className="stepper-body">
          <div className="progress-icons">
            <Row className="text-center mb-3">
              <Col>
                {step > 0 ? (
                  <FontAwesomeIcon icon={faCheck} className="active-icon" />
                ) : (
                  <FontAwesomeIcon icon={faUser} className="active-icon" />
                )}
                <div>Person</div>
              </Col>
              <Col>
                {step > 1 ? (
                  <FontAwesomeIcon icon={faCheck} className="active-icon" />
                ) : (
                  <FontAwesomeIcon icon={faIdCard} className="inactive-icon" />
                )}
                <div>Identity</div>
              </Col>
              <Col>
                {step > 2 ? (
                  <FontAwesomeIcon icon={faCheck} className="active-icon" />
                ) : (
                  <FontAwesomeIcon
                    icon={faCartPlus}
                    className="inactive-icon"
                  />
                )}
                <div>Cart</div>
              </Col>
              <Col>
                {step > 3 ? (
                  <FontAwesomeIcon icon={faCheck} className="active-icon" />
                ) : (
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="inactive-icon"
                  />
                )}
                <div>Location</div>
              </Col>
              {step > 3 && (
                <Col>
                  {step === 4 && !isError ? (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="active-icon-success"
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={isError ? faCircleExclamation : faCheck}
                      className={
                        isError ? "active-icon-error" : "inactive-icon-success"
                      }
                    />
                  )}
                  <div>{isError? "Not Success" : "Success"}</div>
                </Col>
              )}
            </Row>
            <ProgressBar
              now={progressPercentage}
              className="progress-bar-icons"
            />
          </div>
          {step === 0 && (
            <>
              <CartPersonDetails />
              <div className="stepper-buttons">
                <Button onClick={prevStep} disabled>
                  Back
                </Button>
                <Button onClick={nextStep}>Next</Button>
              </div>
            </>
          )}
          {step === 1 && (
            <>
              <Identity />
              <div className="stepper-buttons">
                <Button onClick={prevStep}>Back</Button>
                <Button onClick={nextStep}>Next</Button>
              </div>
            </>
          )}
          {step === 2 && (
            <>
              <CartDetails />
              <div className="stepper-buttons">
                <Button onClick={prevStep}>Back</Button>
                <Button onClick={nextStep}>Next</Button>
              </div>
            </>
          )}
          {step === 3 && (
            <>
              Location
              <div className="stepper-buttons">
                <Button onClick={prevStep}>Back</Button>
                <Button onClick={nextStep}>Next</Button>
              </div>
            </>
          )}
          {step === 4 && (
            <>
              <SuccessMessage
                isError={isError}
                onRetry={retry}
                onFinish={finish}
              />
            </>
          )}
        </CardBody>
      </Card>
    </>
  );
};

export default AddCart;
